// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"76":"common","415":"details","945":"dashboard"}[chunkId] + "." + {"76":"976f94e0","415":"d6b3bf2e","945":"a2c0f380"}[chunkId] + ".css";
};